import type { ComponentProps } from 'react';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent as ShadcnTooltipContent,
  TooltipProvider,
} from '@shadcn/components/ui/tooltip';
import { cn } from '@shadcn/lib/utils';

const TooltipContent = ({
  className,
  collisionPadding = 16,
  ...props
}: ComponentProps<typeof ShadcnTooltipContent>) => (
  <ShadcnTooltipContent
    collisionPadding={collisionPadding}
    className={cn('max-w-[calc(100vw-2rem)] text-wrap', className)}
    {...props}
  />
);

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
